import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

const { Types, Creators } = createActions({
  // Triggers the saga — does not mutate state directly
  requestSpreedlySession: null,
  // Internal saga dispatches
  spreedlySessionLoading: null,
  spreedlySessionSuccess: ['session', 'expiresAtMs'],
  spreedlySessionError: ['error', 'errorStatus'],
  // Dispatched on page unmount or after successful card creation
  clearSpreedlySession: null,
});

export const SpreedlySessionTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable.from({
  // 'idle' | 'loading' | 'ready' | 'error'
  status: 'idle',
  // Decamelized session object from the API (serializable)
  session: null,
  // expires_at converted to milliseconds for easy Date.now() comparison
  expiresAtMs: null,
  // Human-readable error message
  error: '',
  // HTTP status code of the last failure (null on success / idle)
  errorStatus: null,
});

const spreedlySessionLoading = (state) => state.merge({
  status: 'loading',
  error: '',
  errorStatus: null,
});

const spreedlySessionSuccess = (state, { session, expiresAtMs }) => state.merge({
  status: 'ready',
  session,
  expiresAtMs,
  error: '',
  errorStatus: null,
});

const spreedlySessionError = (state, { error, errorStatus }) => state.merge({
  status: 'error',
  session: null,
  expiresAtMs: null,
  error,
  errorStatus,
});

const clearSpreedlySession = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SPREEDLY_SESSION_LOADING]: spreedlySessionLoading,
  [Types.SPREEDLY_SESSION_SUCCESS]: spreedlySessionSuccess,
  [Types.SPREEDLY_SESSION_ERROR]: spreedlySessionError,
  [Types.CLEAR_SPREEDLY_SESSION]: clearSpreedlySession,
});
